import React, { useMemo } from 'react'; // React is sufficient now
import { Stack, FormControlLabel, Checkbox } from "@mui/material";

/**
 * JobTypeFilter is a controlled component that renders a list of checkboxes for job types.
 * It receives its state from a parent component and reports changes back up.
 *
 * @param {object} props - The component props.
 * @param {string} props.jobTypes - The user's preferred job type ("both", "Full time", etc.), which determines which options are available to filter by.
 * @param {object} props.filterCriteria - The current filter state from the parent, containing a `job_type` array of selected values.
 * @param {function} props.handleChangeFilterCriteria - The callback function to execute when a checkbox is changed.
 *
 * @returns {React.ReactElement} A Stack component with a FormControlLabel for each available job type.
 */
const JobTypeFilter = ({ jobTypes, filterCriteria, handleChangeFilterCriteria }) => {

  const availableOptions = useMemo(() => {
    if (jobTypes === 'Full time') {
      return ["Full time"];
    }
    if (jobTypes === 'Part time') {
      return ["Part time", "Temporary", "Internship"];
    }
    return ["Full time", "Part time", "Temporary", "Internship"];
  }, [jobTypes]);

  return (
    <Stack>
      {availableOptions.map((jobType, index) => (
        <FormControlLabel
          key={index}
          control={
            <Checkbox
              checked={filterCriteria.job_type.includes(jobType)}
              onChange={(e) => handleChangeFilterCriteria(e, jobType)}
              name="job_type"
            />
          }
          label={jobType}
        />
      ))}
    </Stack>
  );
};

export default JobTypeFilter;